import { render, staticRenderFns } from "./DialogSelectProject.vue?vue&type=template&id=6954f4bb"
import script from "./DialogSelectProject.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSelectProject.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports